module.exports = __webpack_public_path__ + "static/media/user-blue-icon.e5c0f313.svg";